/**
 * Visual theme — ported from public/js/app.js lines 9-51.
 * Keep in sync with CSS custom properties in styles.css.
 */
export const COLORS = {
  orange:  '#F97316',
  blue:    '#3B82F6',
  green:   '#10B981',
  purple:  '#8B5CF6',
  pink:    '#EC4899',
  teal:    '#14B8A6',
  amber:   '#F59E0B',
  red:     '#EF4444',
  gray:    '#94A3B8',
};

export const PALETTE = Object.values(COLORS);

export const CHART_DEFAULTS = {
  responsive: true,
  maintainAspectRatio: false,
  animation: { duration: 600, easing: 'easeOutQuart' },
  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: '#0D1B35',
      titleColor: '#fff',
      bodyColor: 'rgba(255,255,255,0.7)',
      padding: 10,
      cornerRadius: 8,
      titleFont: { family: 'Inter', weight: '700' },
      bodyFont: { family: 'Inter' },
    }
  },
  scales: {
    x: {
      grid: { display: false },
      ticks: { color: '#94A3B8', font: { family: 'Inter', size: 11 } },
      border: { display: false }
    },
    y: {
      grid: { color: 'rgba(0,0,0,0.04)' },
      ticks: { color: '#94A3B8', font: { family: 'Inter', size: 11 } },
      border: { display: false }
    }
  }
};

export function rateColor(rate) {
  if (rate >= 75) return COLORS.green;
  if (rate >= 50) return COLORS.amber;
  return COLORS.red;
}
